function isDisplayModeStandalone() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  const queries = [
    "(display-mode: standalone)",
    "(display-mode: fullscreen)",
    "(display-mode: minimal-ui)",
  ];

  return queries.some((query) => {
    try {
      return window.matchMedia(query).matches;
    } catch (_error) {
      return false;
    }
  });
}

function isIOSStandalone() {
  if (typeof window === "undefined") {
    return false;
  }

  return window.navigator?.standalone === true;
}

function isAndroidTWAReferrer() {
  if (typeof document === "undefined") {
    return false;
  }

  const referrer = typeof document.referrer === "string" ? document.referrer : "";
  return referrer.startsWith("android-app://");
}

export function isStandalonePWA() {
  return Boolean(
    isDisplayModeStandalone() ||
    isIOSStandalone() ||
    isAndroidTWAReferrer()
  );
}

export function getSuarteEnvironment() {
  const ua =
    (typeof navigator !== "undefined" && typeof navigator.userAgent === "string")
      ? navigator.userAgent
      : "";

  const isNativeWrapper = ua.includes("SuarteApp-iOS");
  const isPWAStandalone = isStandalonePWA();
  const isAndroidTWA = isAndroidTWAReferrer();
  const isApp = isNativeWrapper || isPWAStandalone;

  return {
    isApp,
    isBrowser: !isApp,
    isNativeWrapper,
    isPWAStandalone,
    isAndroidTWA,
  };
}
